import { MRT_ColumnDef } from "material-react-table";

export const dataProvidersColumns: MRT_ColumnDef<any>[] = [
  {
    accessorKey: "firstName",
    header: "First Name",
  },
  {
    accessorKey: "lastName",
    header: "Last Name",
  },
  {
    accessorKey: "email",
    header: "Email Address",
  },
];
